
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text/ai-writer",
      function () {
        return require("private-next-pages/text/ai-writer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text/ai-writer"])
      });
    }
  